import React from 'react'
import { DEFAULT_LIMIT } from '../../../utils/apiUtils'

interface ResultsSummaryProps {
  currentPage: number
  totalResults: number
}

const StandardTableFooterSummary: React.FC<ResultsSummaryProps> = ({
  currentPage,
  totalResults
}) => {
  const start = currentPage === 1 ? 1 : (currentPage - 1) * DEFAULT_LIMIT + 1
  const end = currentPage * DEFAULT_LIMIT > totalResults ? totalResults : currentPage * DEFAULT_LIMIT

  return (
    <div>
      Showing <b>{start}</b> to <b>{end}</b> of <b>{totalResults}</b> results
    </div>
  )
}

export default StandardTableFooterSummary
